// import React, { useState, useEffect } from "react"; 
// import { message as antMessage } from "antd"; 
// import { getAccessToken } from "../../token"; 
// import { API_URL } from "../../Constants"; 
// import toast from "react-hot-toast"; 
// import { useNavigate } from "react-router-dom"; 
// import { motion, AnimatePresence } from "framer-motion"; 

// // --- Icons --- 
// const FiSend = ({ size = 16, className = "" }) => ( 
//   <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><line x1="22" y1="2" x2="11" y2="13"></line><polygon points="22 2 15 22 11 13 2 9 22 2"></polygon></svg> 
// ); 
// const FiFileText = ({ size = 16, className = "" }) => ( 
//   <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg> 
// ); 
// const FiUser = ({ size = 16, className = "" }) => ( 
//   <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg> 
// ); 
// const FiMessageSquare = ({ size = 16, className = "" }) => ( 
//   <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg> 
// ); 
// const FiRefreshCw = ({ size = 16, className = "" }) => ( 
//   <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><polyline points="23 4 23 10 17 10"></polyline><polyline points="1 20 1 14 7 14"></polyline><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path></svg> 
// ); 
// const FiPhone = ({ size = 16, className = "" }) => ( 
//   <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg> 
// ); 

// // --- Form Components --- 
// const FormInput = ({ label, icon: Icon, note, readOnly, ...props }) => ( 
//   <div className="mb-4"> 
//     <label className="block text-[11px] font-bold text-[#0C4550]/70 uppercase tracking-wider mb-1.5 font-manrope"> 
//       {label} {props.required && <span className="text-[#F46653] ml-1">*</span>} 
//     </label> 
//     <div className="relative group"> 
//       <input 
//         {...props} 
//         readOnly={readOnly} 
//         className={`w-full pl-10 pr-3 py-2.5 border rounded-xl text-sm font-semibold outline-none transition-all duration-300 ${ 
//           readOnly  
//             ? "bg-[#F0EFEB]/50 border-slate-200 text-slate-500 cursor-not-allowed"  
//             : "bg-white border-slate-200 text-[#0C4550] placeholder-slate-400 focus:border-[#0C4550] focus:ring-1 focus:ring-[#0C4550] hover:border-[#0C4550]/50 shadow-sm" 
//         }`} 
//       /> 
//       <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none text-slate-400 group-focus-within:text-[#0C4550] transition-colors"> 
//         {Icon && <Icon size={16} />} 
//       </div> 
//     </div> 
//     {note && <p className="mt-1 text-[11px] text-[#0C4550]/60 font-manrope">{note}</p>} 
//   </div> 
// ); 

// const FormTextArea = ({ label, icon: Icon, charCount, maxLength = 160, ...props }) => { 
//   const getCharCountColor = () => { 
//     const percentage = (charCount / maxLength) * 100; 
//     if (percentage >= 90) return 'text-[#F46653]'; 
//     if (percentage >= 80) return 'text-orange-500'; 
//     return 'text-slate-400'; 
//   }; 
//   return ( 
//     <div className="mb-4"> 
//       <div className="flex justify-between items-center mb-1.5"> 
//         <label className="block text-[11px] font-bold text-[#0C4550]/70 uppercase tracking-wider font-manrope"> 
//           {label} {props.required && <span className="text-[#F46653] ml-1">*</span>} 
//         </label> 
//         {maxLength && ( 
//           <span className={`text-[10px] font-bold ${getCharCountColor()} font-manrope`}> 
//             {charCount}/{maxLength} 
//           </span> 
//         )} 
//       </div> 
//       <div className="relative group"> 
//         <textarea 
//           {...props} 
//           className="w-full pl-10 pr-3 py-2.5 bg-white border border-slate-200 rounded-xl text-[#0C4550] placeholder-slate-400 text-sm font-medium focus:border-[#0C4550] focus:ring-1 focus:ring-[#0C4550] outline-none transition-all duration-300 hover:border-[#0C4550]/50 shadow-sm resize-none" 
//         /> 
//         <div className="absolute top-3 left-3 pointer-events-none text-slate-400 group-focus-within:text-[#0C4550] transition-colors"> 
//           {Icon && <Icon size={16} />} 
//         </div> 
//       </div> 
//     </div> 
//   ); 
// }; 

// const FormSelect = ({ label, icon: Icon, options, note, ...props }) => ( 
//   <div className="mb-4"> 
//     <label className="block text-[11px] font-bold text-[#0C4550]/70 uppercase tracking-wider mb-1.5 font-manrope"> 
//       {label} {props.required && <span className="text-[#F46653] ml-1">*</span>} 
//     </label> 
//     <div className="relative group"> 
//       <select 
//         {...props} 
//         className="w-full pl-10 pr-8 py-2.5 bg-white border border-slate-200 rounded-xl text-[#0C4550] text-sm font-semibold focus:border-[#0C4550] focus:ring-1 focus:ring-[#0C4550] outline-none transition-all duration-300 hover:border-[#0C4550]/50 shadow-sm appearance-none disabled:bg-[#F0EFEB]/50 disabled:text-slate-400 cursor-pointer" 
//       > 
//         {options.map((opt) => ( 
//           <option key={opt.value} value={opt.value} disabled={opt.disabled}> 
//             {opt.label} 
//           </option> 
//         ))} 
//       </select> 
//       <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none text-slate-400 group-focus-within:text-[#0C4550] transition-colors"> 
//         {Icon && <Icon size={16} />} 
//       </div> 
//       <div className="absolute inset-y-0 right-3 flex items-center pointer-events-none text-slate-400"> 
//         <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"> 
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" /> 
//         </svg> 
//       </div> 
//     </div> 
//     {note && <p className="mt-1 text-[11px] text-[#0C4550]/60 font-manrope">{note}</p>} 
//   </div> 
// ); 

// const SendSingleSms = () => { 
//   const token = getAccessToken(); 
//   const navigate = useNavigate(); 
  
//   const [isSubmitting, setIsSubmitting] = useState(false); 
//   const [showSuccessOverlay, setShowSuccessOverlay] = useState(false); 
  
//   // Real-Time Clock
//   const [currentTime, setCurrentTime] = useState(new Date()); 

//   // --- DLT State ---
//   const [peId, setPeId] = useState("");
//   const [senderIds, setSenderIds] = useState([]);
//   const [allTemplates, setAllTemplates] = useState([]);
//   const [filteredTemplates, setFilteredTemplates] = useState([]);

//   const [formData, setFormData] = useState({ 
//     phoneNumber: "", 
//     message: "", 
//     senderId: "", 
//     templateID: ""
//   }); 

//   // Clock interval
//   useEffect(() => { 
//     const timer = setInterval(() => setCurrentTime(new Date()), 1000); 
//     return () => clearInterval(timer); 
//   }, []); 

//   // Fetch DLT Profile, Sender IDs, and Templates on mount
//   useEffect(() => {
//     const fetchDltData = async () => {
//       if (!token) return;

//       const headers = {
//         "Authorization": `Bearer ${token}`,
//         "Content-Type": "application/json"
//       };

//       try {
//         // 1. Fetch PE ID in the background
//         const profileRes = await fetch(`${API_URL}/api/dlt/profile`, { headers });
//         if (profileRes.ok) {
//           const profileData = await profileRes.json();
//           setPeId(profileData.peId || "");
//         }

//         // 2. Fetch Sender IDs
//         const senderRes = await fetch(`${API_URL}/api/dlt/sender-ids`, { headers });
//         if (senderRes.ok) {
//           const senderData = await senderRes.json();
//           // Extract just the 'header' string from the DltSenderId objects
//           setSenderIds(senderData.map(s => s.header));
//         }

//         // 3. Fetch Templates
//         const templateRes = await fetch(`${API_URL}/api/dlt/templates`, { headers });
//         if (templateRes.ok) {
//           const templateData = await templateRes.json();
//           setAllTemplates(templateData);
//         }
//       } catch (error) {
//         antMessage.error("Failed to load DLT configuration");
//       }
//     };

//     fetchDltData();
//   }, [token]);

//   // Filter templates when a Sender ID is selected
//   useEffect(() => { 
//     if (!formData.senderId) { 
//       setFilteredTemplates([]); 
//       setFormData(prev => ({ ...prev, templateID: "", message: "" }));
//     } else { 
//       // Filter templates where the 'senderIds' array includes the selected senderId
//       const filtered = allTemplates.filter(t => 
//         t.senderIds && t.senderIds.includes(formData.senderId)
//       ); 
//       setFilteredTemplates(filtered); 
//     } 
//   }, [formData.senderId, allTemplates]); 

//   // Auto-fill message content when a Template is selected
//   useEffect(() => { 
//     if (formData.templateID) { 
//       const selectedTemp = allTemplates.find(t => t.templateId === formData.templateID);
//       if (selectedTemp) {
//         setFormData(prev => ({ ...prev, message: selectedTemp.content })); 
//       }
//     } 
//   }, [formData.templateID, allTemplates]); 

//   const handleChange = (e) => { 
//     const { name, value } = e.target; 
//     if (name === "senderId") { 
//         setFormData(prev => ({ ...prev, [name]: value, templateID: "", message: "" })); 
//     } else { 
//         setFormData(prev => ({ ...prev, [name]: value })); 
//     } 
//   }; 

//   const resetForm = () => { 
//     setFormData({ phoneNumber: "", message: "", senderId: "", templateID: "" }); 
//   }; 

//   const handleSubmit = async (e) => { 
//     e.preventDefault(); 
    
//     if (!peId) {
//        toast.error("No registered PE ID found. Please update your DLT profile.");
//        return;
//     }

//     setIsSubmitting(true); 
      
//     // Payload mapping based on the Spring Boot SingleSmsRequest DTO
//     const payload = { 
//       recipientNumber: formData.phoneNumber.trim(), 
//       senderId: formData.senderId, 
//       templateId: formData.templateID, 
//       messageContent: formData.message, 
//       peId: peId // Included in background as requested
//     }; 

//     try { 
//       const response = await fetch (`${API_URL}/api/v1/sms/send`, { 
//         method: "POST", 
//         headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` }, 
//         body: JSON.stringify(payload), 
//       }); 
        
//       let result = null; 
//       try { result = await response.json(); } catch { result = null; } 
        
//       if (response.ok) { 
//         setShowSuccessOverlay(true); 
//         toast.success("SMS Submitted Successfully"); 
//         resetForm(); 
//         setTimeout(() => setShowSuccessOverlay(false), 3000); 
//       } else { 
//         toast.error(result?.message || "Failed to send SMS"); 
//       } 
//     } catch (error) { 
//       toast.error("Network error occurred"); 
//     } finally { 
//       setIsSubmitting(false); 
//     } 
//   }; 

//   // Format Helpers
//   const formatTopTime = (date) => date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }); 
//   const formatSubHeaderDate = (date) => { 
//     const day = date.toLocaleDateString('en-US', { weekday: 'short' }); 
//     const fullDate = date.toLocaleDateString('en-US', { day: '2-digit', month: 'short', year: 'numeric' }); 
//     const time = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }); 
//     return `${day}, ${fullDate} • ${time}`; 
//   }; 

//   // Select Options Generation
//   const senderOptions = [ 
//     { value: "", label: "Select Sender ID", disabled: true }, 
//     ...senderIds.map(id => ({ value: id, label: id })) 
//   ]; 

//   const templateOptions = [ 
//     { value: "", label: "Select Template ID", disabled: true }, 
//     ...filteredTemplates.map(t => ({ value: t.templateId, label: t.templateId })) 
//   ]; 

//   return ( 
//     <div className="min-h-screen bg-[#F0EFEB] p-4 font-sans flex justify-center text-[#0C4550]"> 
//       <style>{` 
//         @import url('https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800&display=swap'); 
//         .font-manrope { font-family: 'Manrope', sans-serif; } 
//       `}</style> 

//       <div className="w-full max-w-3xl space-y-4"> 
//         {/* Header */} 
//         <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 bg-white/40 backdrop-blur-md px-4 py-3 rounded-2xl border border-white/50 shadow-sm"> 
//           <div className="pl-1"> 
//             <h1 className="text-xl font-extrabold text-[#0C4550] font-manrope">Single SMS Transmission</h1> 
//             <p className="text-[#0C4550]/60 text-xs font-medium mt-0.5 font-manrope">Send individual transactional or OTP messages securely</p> 
//           </div> 
//           <button 
//             onClick={resetForm} 
//             className="flex items-center gap-1.5 px-4 py-2 bg-white border border-transparent text-[#0C4550] font-bold rounded-lg hover:bg-[#F46653]/10 hover:text-[#F46653] transition-all duration-300 text-xs shadow-sm font-manrope" 
//           > 
//             <FiRefreshCw size={13} /> Reset Form 
//           </button> 
//         </div> 

//         <div className="grid grid-cols-1 lg:grid-cols-12 gap-5"> 
//           {/* Main Form Area */} 
//           <div className="lg:col-span-8"> 
//             <div className="bg-white rounded-xl shadow-[0_4px_20px_-4px_rgba(12,69,80,0.05)] border border-white overflow-hidden"> 
//               <div className="px-5 py-3 bg-[#0C4550]/5 border-b border-[#F0EFEB] flex items-center justify-between"> 
//                 <div className="flex items-center gap-3"> 
//                   <div className="w-8 h-8 rounded-lg bg-[#0C4550] flex items-center justify-center text-white shadow-lg shadow-[#0C4550]/20"> 
//                     <FiSend className="w-4 h-4" /> 
//                   </div> 
//                   <div> 
//                     <p className="font-bold text-[#0C4550] font-manrope text-sm">Compose Message</p> 
//                     <p className="text-[#0C4550]/50 text-[10px] font-medium font-manrope">Select headers and template to proceed</p> 
//                   </div> 
//                 </div> 
//               </div> 

//               <form onSubmit={handleSubmit} className="p-5"> 
//                 <div className="flex flex-col"> 
//                   <FormSelect  
//                       label="Sender ID"  
//                       name="senderId"  
//                       value={formData.senderId}  
//                       onChange={handleChange}  
//                       icon={FiUser} 
//                       options={senderOptions} 
//                       required  
//                   /> 
//                   <FormSelect  
//                       label="Template ID"  
//                       name="templateID"  
//                       value={formData.templateID}  
//                       onChange={handleChange}  
//                       icon={FiFileText} 
//                       options={templateOptions} 
//                       required  
//                       note={!formData.senderId ? "Select a Sender ID to view linked templates." : "Matching templates for selected Sender."} 
//                   /> 
//                   <FormTextArea  
//                     label="Message Content"  
//                     name="message"  
//                     value={formData.message}  
//                     onChange={handleChange}  
//                     placeholder="Content will auto-fill from template..."  
//                     icon={FiMessageSquare} 
//                     required  
//                     rows={4} 
//                     charCount={formData.message.length} 
//                   /> 
//                   <FormInput  
//                     label="Recipient Number"  
//                     name="phoneNumber"  
//                     value={formData.phoneNumber}  
//                     onChange={handleChange}  
//                     placeholder="e.g. 919876543210"  
//                     icon={FiPhone} 
//                     required  
//                   /> 
//                 </div> 

//                 <div className="mt-2 pt-4 border-t border-[#F0EFEB]"> 
//                   <button 
//                     type="submit" 
//                     disabled={isSubmitting} 
//                     className="w-full px-6 py-3 bg-[#0C4550] text-white font-bold rounded-xl transition-all duration-300 disabled:opacity-70 disabled:cursor-not-allowed flex items-center justify-center gap-2 hover:bg-[#08313a] shadow-lg shadow-[#0C4550]/20 hover:shadow-xl hover:-translate-y-0.5 font-manrope text-sm" 
//                   > 
//                     {isSubmitting ? ( 
//                       <> 
//                         <div className="w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin"></div> 
//                         Processing... 
//                       </> 
//                     ) : ( 
//                       <> 
//                         <FiSend size={16} /> Send Message 
//                       </> 
//                     )} 
//                   </button> 
//                 </div> 
//               </form> 
//             </div> 
//           </div> 

//           {/* Right Column - Phone Mockup */} 
//           <div className="lg:col-span-4 flex flex-col items-center"> 
//             <div className="relative w-[240px] h-[480px] bg-white border-[6px] border-[#0C4550] rounded-[3rem] shadow-2xl flex flex-col overflow-hidden"> 
               
//               {/* Speaker/Notch */} 
//               <div className="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-6 bg-[#0C4550] rounded-b-2xl z-20 flex items-center justify-center"> 
//                 <div className="w-8 h-1 bg-white/20 rounded-full"></div> 
//               </div> 
               
//               {/* PREMIUM SUCCESS OVERLAY */} 
//               <AnimatePresence> 
//                 {showSuccessOverlay && ( 
//                   <motion.div  
//                     initial={{ opacity: 0 }} 
//                     animate={{ opacity: 1 }} 
//                     exit={{ opacity: 0 }} 
//                     className="absolute inset-0 z-50 bg-[#0C4550]/95 backdrop-blur-md flex flex-col items-center justify-center px-6 text-center" 
//                   > 
//                     <motion.div 
//                       initial={{ scale: 0, rotate: -45 }} 
//                       animate={{ scale: 1, rotate: 0 }} 
//                       transition={{ type: "spring", damping: 12, stiffness: 200 }} 
//                       className="w-20 h-20 bg-white rounded-full flex items-center justify-center shadow-2xl mb-6" 
//                     > 
//                       <motion.svg  
//                         width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#F46653" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" 
//                         initial={{ pathLength: 0 }} 
//                         animate={{ pathLength: 1 }} 
//                         transition={{ delay: 0.2, duration: 0.5 }} 
//                       > 
//                         <polyline points="20 6 9 17 4 12"></polyline> 
//                       </motion.svg> 
//                     </motion.div> 
                     
//                     <motion.div 
//                       initial={{ y: 20, opacity: 0 }} 
//                       animate={{ y: 0, opacity: 1 }} 
//                       transition={{ delay: 0.4 }} 
//                     > 
//                       <h2 className="text-white font-extrabold font-manrope text-xl tracking-tight">SUCCESS!</h2> 
//                       <p className="text-white/60 text-[10px] font-bold mt-2 font-manrope uppercase tracking-widest leading-tight"> 
//                         Message Sent <br /> Successfully 
//                       </p> 
//                     </motion.div> 
//                   </motion.div> 
//                 )} 
//               </AnimatePresence> 

//               {/* Screen Content */} 
//               <div className="flex-1 bg-[#F9FAFB] m-1 rounded-[2.2rem] overflow-hidden flex flex-col"> 
//                 {/* Status Bar */} 
//                 <div className="h-8 flex justify-between items-center px-6 pt-2"> 
//                   <span className="text-[10px] font-bold text-[#0C4550] font-manrope"> 
//                     {formatTopTime(currentTime)} 
//                   </span> 
//                   <div className="flex gap-1 items-center"> 
//                     <div className="w-2.5 h-2.5 rounded-full border border-[#0C4550]/20"></div> 
//                     <div className="w-3 h-2 bg-[#0C4550]/30 rounded-sm"></div> 
//                   </div> 
//                 </div> 

//                 {/* Message Live Preview UI */} 
//                 <div className="flex-1 p-4 flex flex-col"> 
//                   {/* SMS Header */} 
//                   <div className="flex flex-col items-center mb-6 mt-4"> 
//                     <div className="w-11 h-11 bg-[#0C4550]/10 rounded-full flex items-center justify-center mb-2"> 
//                       <FiUser size={22} className="text-[#0C4550]/40" /> 
//                     </div> 
//                     <p className="text-[11px] font-extrabold text-[#0C4550] uppercase tracking-tight font-manrope"> 
//                       {formData.senderId || "Sender ID"} 
//                     </p> 
//                     <div className="text-center mt-1"> 
//                       <p className="text-[9px] font-bold text-slate-500 font-manrope">SMS</p> 
//                       <p className="text-[8px] text-slate-400 font-manrope"> 
//                         {formatSubHeaderDate(currentTime)} 
//                       </p> 
//                     </div> 
//                   </div> 

//                   {/* Message Bubble Logic */} 
//                   <div className="flex flex-col gap-2"> 
//                     {formData.message ? ( 
//                       <div className="self-start max-w-[90%] bg-[#E9E9EB] text-[#0C4550] p-3 rounded-2xl rounded-tl-none text-[11px] leading-relaxed shadow-sm font-medium animate-in fade-in slide-in-from-left-2 duration-300"> 
//                         {formData.message} 
//                       </div> 
//                     ) : ( 
//                       <div className="self-center mt-12 text-center opacity-40"> 
//                         <p className="text-[10px] font-bold text-[#0C4550] font-manrope uppercase tracking-widest">Live Preview</p> 
//                         <p className="text-[9px] text-[#0C4550] mt-1 italic px-4 leading-tight">Fill the form to see a live simulation of your SMS</p> 
//                       </div> 
//                     )} 
//                   </div> 
//                 </div> 
//               </div> 

//               {/* Home Indicator */} 
//               <div className="h-8 flex justify-center items-center"> 
//                 <div className="w-16 h-1 bg-[#0C4550]/10 rounded-full"></div> 
//               </div> 
//             </div> 

//             {/* Navigation Link Below Phone */} 
//             <div className="mt-6"> 
//               <button 
//                 onClick={() => navigate('/reports')} 
//                 className="text-[#0C4550] font-bold text-sm underline underline-offset-4 decoration-[#0C4550]/30 hover:decoration-[#F46653] transition-all duration-300 font-manrope" 
//               > 
//                 Check Reports &rarr; 
//               </button> 
//             </div> 
//           </div> 
//         </div> 
//       </div> 
//     </div> 
//   ); 
// }; 

// export default SendSingleSms;





// import React, { useState, useEffect } from "react"; 
// import { message as antMessage } from "antd"; 
// import { getAccessToken } from "../../token"; 
// import { API_URL } from "../../Constants"; 
// import toast from "react-hot-toast"; 
// import { useNavigate } from "react-router-dom"; 
// import { motion, AnimatePresence } from "framer-motion"; 

// // --- Icons --- 
// const FiSend = ({ size = 16, className = "" }) => ( 
//   <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><line x1="22" y1="2" x2="11" y2="13"></line><polygon points="22 2 15 22 11 13 2 9 22 2"></polygon></svg> 
// ); 
// const FiFileText = ({ size = 16, className = "" }) => ( 
//   <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg> 
// ); 
// const FiUser = ({ size = 16, className = "" }) => ( 
//   <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg> 
// ); 
// const FiMessageSquare = ({ size = 16, className = "" }) => ( 
//   <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg> 
// ); 
// const FiRefreshCw = ({ size = 16, className = "" }) => ( 
//   <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><polyline points="23 4 23 10 17 10"></polyline><polyline points="1 20 1 14 7 14"></polyline><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path></svg> 
// ); 
// const FiPhone = ({ size = 16, className = "" }) => ( 
//   <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg> 
// ); 
// const FiAlertCircle = ({ size = 16, className = "" }) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
// );

// // --- Form Components --- 
// const FormInput = ({ label, icon: Icon, note, readOnly, ...props }) => ( 
//   <div className="mb-4"> 
//     <label className="block text-[11px] font-bold text-[#0C4550]/70 uppercase tracking-wider mb-1.5 font-manrope"> 
//       {label} {props.required && <span className="text-[#F46653] ml-1">*</span>} 
//     </label> 
//     <div className="relative group"> 
//       <input 
//         {...props} 
//         readOnly={readOnly} 
//         className={`w-full pl-10 pr-3 py-2.5 border rounded-xl text-sm font-semibold outline-none transition-all duration-300 ${ 
//           readOnly  
//             ? "bg-[#F0EFEB]/50 border-slate-200 text-slate-500 cursor-not-allowed"  
//             : "bg-white border-slate-200 text-[#0C4550] placeholder-slate-400 focus:border-[#0C4550] focus:ring-1 focus:ring-[#0C4550] hover:border-[#0C4550]/50 shadow-sm" 
//         }`} 
//       /> 
//       <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none text-slate-400 group-focus-within:text-[#0C4550] transition-colors"> 
//         {Icon && <Icon size={16} />} 
//       </div> 
//     </div> 
//     {note && <p className="mt-1 text-[11px] text-[#0C4550]/60 font-manrope">{note}</p>} 
//   </div> 
// ); 

// const FormTextArea = ({ label, icon: Icon, charCount, maxLength = 160, encodingLabel = "GSM-7", ...props }) => { 
//   const getCharCountColor = () => { 
//     const percentage = (charCount / maxLength) * 100; 
//     if (percentage >= 100) return 'text-[#F46653]'; 
//     if (percentage >= 80) return 'text-orange-500'; 
//     return 'text-slate-400'; 
//   }; 
//   return ( 
//     <div className="mb-4"> 
//       <div className="flex justify-between items-center mb-1.5"> 
//         <label className="block text-[11px] font-bold text-[#0C4550]/70 uppercase tracking-wider font-manrope"> 
//           {label} {props.required && <span className="text-[#F46653] ml-1">*</span>} 
//         </label> 
//         <div className="flex items-center gap-2">
//           <span className="text-[9px] font-extrabold text-[#0C4550]/40 px-1.5 py-0.5 border border-[#0C4550]/10 rounded bg-[#F0EFEB] font-manrope">{encodingLabel}</span>
//           <span className={`text-[10px] font-bold ${getCharCountColor()} font-manrope`}> 
//             {charCount}/{maxLength} 
//           </span> 
//         </div>
//       </div> 
//       <div className="relative group"> 
//         <textarea 
//           {...props} 
//           className="w-full pl-10 pr-3 py-2.5 bg-white border border-slate-200 rounded-xl text-[#0C4550] placeholder-slate-400 text-sm font-medium focus:border-[#0C4550] focus:ring-1 focus:ring-[#0C4550] outline-none transition-all duration-300 hover:border-[#0C4550]/50 shadow-sm resize-none" 
//         /> 
//         <div className="absolute top-3 left-3 pointer-events-none text-slate-400 group-focus-within:text-[#0C4550] transition-colors"> 
//           {Icon && <Icon size={16} />} 
//         </div> 
//       </div> 
//     </div> 
//   ); 
// }; 

// const FormSelect = ({ label, icon: Icon, options, note, ...props }) => ( 
//   <div className="mb-4"> 
//     <label className="block text-[11px] font-bold text-[#0C4550]/70 uppercase tracking-wider mb-1.5 font-manrope"> 
//       {label} {props.required && <span className="text-[#F46653] ml-1">*</span>} 
//     </label> 
//     <div className="relative group"> 
//       <select 
//         {...props} 
//         className="w-full pl-10 pr-8 py-2.5 bg-white border border-slate-200 rounded-xl text-[#0C4550] text-sm font-semibold focus:border-[#0C4550] focus:ring-1 focus:ring-[#0C4550] outline-none transition-all duration-300 hover:border-[#0C4550]/50 shadow-sm appearance-none disabled:bg-[#F0EFEB]/50 disabled:text-slate-400 cursor-pointer" 
//       > 
//         {options.map((opt) => ( 
//           <option key={opt.value} value={opt.value} disabled={opt.disabled}> 
//             {opt.label} 
//           </option> 
//         ))} 
//       </select> 
//       <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none text-slate-400 group-focus-within:text-[#0C4550] transition-colors"> 
//         {Icon && <Icon size={16} />} 
//       </div> 
//       <div className="absolute inset-y-0 right-3 flex items-center pointer-events-none text-slate-400"> 
//         <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"> 
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" /> 
//         </svg> 
//       </div> 
//     </div> 
//     {note && <p className="mt-1 text-[11px] text-[#0C4550]/60 font-manrope">{note}</p>} 
//   </div> 
// ); 

// const SendSingleSms = () => { 
//   const token = getAccessToken(); 
//   const navigate = useNavigate(); 
  
//   const [isSubmitting, setIsSubmitting] = useState(false); 
//   const [showSuccessOverlay, setShowSuccessOverlay] = useState(false); 
  
//   // Real-Time Clock
//   const [currentTime, setCurrentTime] = useState(new Date()); 

//   // --- DLT State ---
//   const [peId, setPeId] = useState("");
//   const [senderIds, setSenderIds] = useState([]);
//   const [allTemplates, setAllTemplates] = useState([]);
//   const [filteredTemplates, setFilteredTemplates] = useState([]);

//   // --- SMS Logic State ---
//   const [smsLimit, setSmsLimit] = useState(160);
//   const [encodingLabel, setEncodingLabel] = useState("GSM-7");
//   const [showLimitWarning, setShowLimitWarning] = useState(false);

//   const [formData, setFormData] = useState({ 
//     phoneNumber: "", 
//     message: "", 
//     senderId: "", 
//     templateID: ""
//   }); 

//   // Clock interval
//   useEffect(() => { 
//     const timer = setInterval(() => setCurrentTime(new Date()), 1000); 
//     return () => clearInterval(timer); 
//   }, []); 

//   // Fetch DLT Profile, Sender IDs, and Templates on mount
//   useEffect(() => {
//     const fetchDltData = async () => {
//       if (!token) return;

//       const headers = {
//         "Authorization": `Bearer ${token}`,
//         "Content-Type": "application/json"
//       };

//       try {
//         const profileRes = await fetch(`${API_URL}/api/dlt/profile`, { headers });
//         if (profileRes.ok) {
//           const profileData = await profileRes.json();
//           setPeId(profileData.peId || "");
//         }

//         const senderRes = await fetch(`${API_URL}/api/dlt/sender-ids`, { headers });
//         if (senderRes.ok) {
//           const senderData = await senderRes.json();
//           setSenderIds(senderData.map(s => s.header));
//         }

//         const templateRes = await fetch(`${API_URL}/api/dlt/templates`, { headers });
//         if (templateRes.ok) {
//           const templateData = await templateRes.json();
//           setAllTemplates(templateData);
//         }
//       } catch (error) {
//         antMessage.error("Failed to load DLT configuration");
//       }
//     };

//     fetchDltData();
//   }, [token]);

//   // Encoding detection logic
//   const detectEncoding = (text) => {
//     const gsm7Basic = "@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !\"#¤%&'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà";
//     const gsm7Extended = "^{}\\[]~|€";
    
//     for (let i = 0; i < text.length; i++) {
//         if (!gsm7Basic.includes(text[i]) && !gsm7Extended.includes(text[i])) {
//             return "UNICODE";
//         }
//     }
//     return "GSM-7";
//   };

//   // Handle encoding and limit updates
//   useEffect(() => {
//     const encoding = detectEncoding(formData.message);
//     const limit = encoding === "UNICODE" ? 70 : 160;
    
//     setEncodingLabel(encoding);
//     setSmsLimit(limit);

//     // Show warning if text exceeds current segment limit
//     if (formData.message.length > limit) {
//         setShowLimitWarning(true);
//     } else {
//         setShowLimitWarning(false);
//     }
//   }, [formData.message]);

//   // Filter templates when a Sender ID is selected
//   useEffect(() => { 
//     if (!formData.senderId) { 
//       setFilteredTemplates([]); 
//       setFormData(prev => ({ ...prev, templateID: "", message: "" }));
//     } else { 
//       const filtered = allTemplates.filter(t => 
//         t.senderIds && t.senderIds.includes(formData.senderId)
//       ); 
//       setFilteredTemplates(filtered); 
//     } 
//   }, [formData.senderId, allTemplates]); 

//   // Auto-fill message content when a Template is selected
//   useEffect(() => { 
//     if (formData.templateID) { 
//       const selectedTemp = allTemplates.find(t => t.templateId === formData.templateID);
//       if (selectedTemp) {
//         setFormData(prev => ({ ...prev, message: selectedTemp.content })); 
//       }
//     } 
//   }, [formData.templateID, allTemplates]); 

//   const handleChange = (e) => { 
//     const { name, value } = e.target; 
//     if (name === "senderId") { 
//         setFormData(prev => ({ ...prev, [name]: value, templateID: "", message: "" })); 
//     } else { 
//         setFormData(prev => ({ ...prev, [name]: value })); 
//     } 
//   }; 

//   const resetForm = () => { 
//     setFormData({ phoneNumber: "", message: "", senderId: "", templateID: "" }); 
//   }; 

//   const handleSubmit = async (e) => { 
//     e.preventDefault(); 
    
//     if (!peId) {
//        toast.error("No registered PE ID found. Please update your DLT profile.");
//        return;
//     }

//     setIsSubmitting(true); 
      
//     const payload = { 
//       recipientNumber: formData.phoneNumber.trim(), 
//       senderId: formData.senderId, 
//       templateId: formData.templateID, 
//       messageContent: formData.message, 
//       peId: peId 
//     }; 

//     try { 
//       const response = await fetch (`${API_URL}/api/v1/sms/send`, { 
//         method: "POST", 
//         headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` }, 
//         body: JSON.stringify(payload), 
//       }); 
        
//       let result = null; 
//       try { result = await response.json(); } catch { result = null; } 
        
//       if (response.ok) { 
//         setShowSuccessOverlay(true); 
//         toast.success("SMS Submitted Successfully"); 
//         resetForm(); 
//         setTimeout(() => setShowSuccessOverlay(false), 3000); 
//       } else { 
//         toast.error(result?.message || "Failed to send SMS"); 
//       } 
//     } catch (error) { 
//       toast.error("Network error occurred"); 
//     } finally { 
//       setIsSubmitting(false); 
//     } 
//   }; 

//   const formatTopTime = (date) => date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }); 
//   const formatSubHeaderDate = (date) => { 
//     const day = date.toLocaleDateString('en-US', { weekday: 'short' }); 
//     const fullDate = date.toLocaleDateString('en-US', { day: '2-digit', month: 'short', year: 'numeric' }); 
//     const time = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }); 
//     return `${day}, ${fullDate} • ${time}`; 
//   }; 

//   const senderOptions = [ 
//     { value: "", label: "Select Sender ID", disabled: true }, 
//     ...senderIds.map(id => ({ value: id, label: id })) 
//   ]; 

//   const templateOptions = [ 
//     { value: "", label: "Select Template ID", disabled: true }, 
//     ...filteredTemplates.map(t => ({ value: t.templateId, label: t.templateId })) 
//   ]; 

//   return ( 
//     <div className="min-h-screen bg-[#F0EFEB] p-4 font-sans flex justify-center text-[#0C4550]"> 
//       <style>{` 
//         @import url('https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800&display=swap'); 
//         .font-manrope { font-family: 'Manrope', sans-serif; } 
//       `}</style> 

//       <div className="w-full max-w-3xl space-y-4"> 
//         {/* Header */} 
//         <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 bg-white/40 backdrop-blur-md px-4 py-3 rounded-2xl border border-white/50 shadow-sm"> 
//           <div className="pl-1"> 
//             <h1 className="text-xl font-extrabold text-[#0C4550] font-manrope">Single SMS Transmission</h1> 
//             <p className="text-[#0C4550]/60 text-xs font-medium mt-0.5 font-manrope">Send individual transactional or OTP messages securely</p> 
//           </div> 
//           <button 
//             onClick={resetForm} 
//             className="flex items-center gap-1.5 px-4 py-2 bg-white border border-transparent text-[#0C4550] font-bold rounded-lg hover:bg-[#F46653]/10 hover:text-[#F46653] transition-all duration-300 text-xs shadow-sm font-manrope" 
//           > 
//             <FiRefreshCw size={13} /> Reset Form 
//           </button> 
//         </div> 

//         <div className="grid grid-cols-1 lg:grid-cols-12 gap-5"> 
//           {/* Main Form Area */} 
//           <div className="lg:col-span-8"> 
//             <div className="bg-white rounded-xl shadow-[0_4px_20px_-4px_rgba(12,69,80,0.05)] border border-white overflow-hidden"> 
//               <div className="px-5 py-3 bg-[#0C4550]/5 border-b border-[#F0EFEB] flex items-center justify-between"> 
//                 <div className="flex items-center gap-3"> 
//                   <div className="w-8 h-8 rounded-lg bg-[#0C4550] flex items-center justify-center text-white shadow-lg shadow-[#0C4550]/20"> 
//                     <FiSend className="w-4 h-4" /> 
//                   </div> 
//                   <div> 
//                     <p className="font-bold text-[#0C4550] font-manrope text-sm">Compose Message</p> 
//                     <p className="text-[#0C4550]/50 text-[10px] font-medium font-manrope">Select headers and template to proceed</p> 
//                   </div> 
//                 </div> 
//               </div> 

//               <form onSubmit={handleSubmit} className="p-5"> 
//                 <div className="flex flex-col"> 
//                   <FormSelect  
//                       label="Sender ID"  
//                       name="senderId"  
//                       value={formData.senderId}  
//                       onChange={handleChange}  
//                       icon={FiUser} 
//                       options={senderOptions} 
//                       required  
//                   /> 
//                   <FormSelect  
//                       label="Template ID"  
//                       name="templateID"  
//                       value={formData.templateID}  
//                       onChange={handleChange}  
//                       icon={FiFileText} 
//                       options={templateOptions} 
//                       required  
//                       note={!formData.senderId ? "Select a Sender ID to view linked templates." : "Matching templates for selected Sender."} 
//                   /> 

//                   {/* Character Limit Logic Implemented Here */}
//                   <FormTextArea  
//                     label="Message Content"  
//                     name="message"  
//                     value={formData.message}  
//                     onChange={handleChange}  
//                     placeholder="Content will auto-fill from template..."  
//                     icon={FiMessageSquare} 
//                     required  
//                     rows={4} 
//                     charCount={formData.message.length} 
//                     maxLength={smsLimit}
//                     encodingLabel={encodingLabel}
//                   /> 

//                   {/* Limit Warning Popup */}
//                   <AnimatePresence>
//                     {showLimitWarning && (
//                       <motion.div 
//                         initial={{ opacity: 0, y: -10 }}
//                         animate={{ opacity: 1, y: 0 }}
//                         exit={{ opacity: 0, y: -10 }}
//                         className="mb-4 p-3 bg-orange-50 border border-orange-200 rounded-xl flex items-start gap-3 shadow-sm"
//                       >
//                         <div className="mt-0.5 text-orange-500">
//                           <FiAlertCircle size={18} />
//                         </div>
//                         <div>
//                           <p className="text-[11px] font-bold text-orange-800 font-manrope uppercase">Message Limit Exceeded</p>
//                           <p className="text-[10px] text-orange-700 font-medium font-manrope leading-tight mt-0.5">
//                             Your message exceeds the {smsLimit} character limit for {encodingLabel} encoding. 
//                             It will be processed and charged as <span className="font-bold">2 or more messages</span>.
//                           </p>
//                         </div>
//                       </motion.div>
//                     )}
//                   </AnimatePresence>

//                   <FormInput  
//                     label="Recipient Number"  
//                     name="phoneNumber"  
//                     value={formData.phoneNumber}  
//                     onChange={handleChange}  
//                     placeholder="e.g. 919876543210"  
//                     icon={FiPhone} 
//                     required  
//                   /> 
//                 </div> 

//                 <div className="mt-2 pt-4 border-t border-[#F0EFEB]"> 
//                   <button 
//                     type="submit" 
//                     disabled={isSubmitting} 
//                     className="w-full px-6 py-3 bg-[#0C4550] text-white font-bold rounded-xl transition-all duration-300 disabled:opacity-70 disabled:cursor-not-allowed flex items-center justify-center gap-2 hover:bg-[#08313a] shadow-lg shadow-[#0C4550]/20 hover:shadow-xl hover:-translate-y-0.5 font-manrope text-sm" 
//                   > 
//                     {isSubmitting ? ( 
//                       <> 
//                         <div className="w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin"></div> 
//                         Processing... 
//                       </> 
//                     ) : ( 
//                       <> 
//                         <FiSend size={16} /> Send Message 
//                       </> 
//                     )} 
//                   </button> 
//                 </div> 
//               </form> 
//             </div> 
//           </div> 

//           {/* Right Column - Phone Mockup */} 
//           <div className="lg:col-span-4 flex flex-col items-center"> 
//             <div className="relative w-[240px] h-[480px] bg-white border-[6px] border-[#0C4550] rounded-[3rem] shadow-2xl flex flex-col overflow-hidden"> 
                
//               {/* Speaker/Notch */} 
//               <div className="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-6 bg-[#0C4550] rounded-b-2xl z-20 flex items-center justify-center"> 
//                 <div className="w-8 h-1 bg-white/20 rounded-full"></div> 
//               </div> 
                
//               {/* PREMIUM SUCCESS OVERLAY */} 
//               <AnimatePresence> 
//                 {showSuccessOverlay && ( 
//                   <motion.div  
//                     initial={{ opacity: 0 }} 
//                     animate={{ opacity: 1 }} 
//                     exit={{ opacity: 0 }} 
//                     className="absolute inset-0 z-50 bg-[#0C4550]/95 backdrop-blur-md flex flex-col items-center justify-center px-6 text-center" 
//                   > 
//                     <motion.div 
//                       initial={{ scale: 0, rotate: -45 }} 
//                       animate={{ scale: 1, rotate: 0 }} 
//                       transition={{ type: "spring", damping: 12, stiffness: 200 }} 
//                       className="w-20 h-20 bg-white rounded-full flex items-center justify-center shadow-2xl mb-6" 
//                     > 
//                       <motion.svg  
//                         width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#F46653" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" 
//                         initial={{ pathLength: 0 }} 
//                         animate={{ pathLength: 1 }} 
//                         transition={{ delay: 0.2, duration: 0.5 }} 
//                       > 
//                         <polyline points="20 6 9 17 4 12"></polyline> 
//                       </motion.svg> 
//                     </motion.div> 
                      
//                     <motion.div 
//                       initial={{ y: 20, opacity: 0 }} 
//                       animate={{ y: 0, opacity: 1 }} 
//                       transition={{ delay: 0.4 }} 
//                     > 
//                       <h2 className="text-white font-extrabold font-manrope text-xl tracking-tight">SUCCESS!</h2> 
//                       <p className="text-white/60 text-[10px] font-bold mt-2 font-manrope uppercase tracking-widest leading-tight"> 
//                         Message Sent <br /> Successfully 
//                       </p> 
//                     </motion.div> 
//                   </motion.div> 
//                 )} 
//               </AnimatePresence> 

//               {/* Screen Content */} 
//               <div className="flex-1 bg-[#F9FAFB] m-1 rounded-[2.2rem] overflow-hidden flex flex-col"> 
//                 <div className="h-8 flex justify-between items-center px-6 pt-2"> 
//                   <span className="text-[10px] font-bold text-[#0C4550] font-manrope"> 
//                     {formatTopTime(currentTime)} 
//                   </span> 
//                   <div className="flex gap-1 items-center"> 
//                     <div className="w-2.5 h-2.5 rounded-full border border-[#0C4550]/20"></div> 
//                     <div className="w-3 h-2 bg-[#0C4550]/30 rounded-sm"></div> 
//                   </div> 
//                 </div> 

//                 <div className="flex-1 p-4 flex flex-col"> 
//                   <div className="flex flex-col items-center mb-6 mt-4"> 
//                     <div className="w-11 h-11 bg-[#0C4550]/10 rounded-full flex items-center justify-center mb-2"> 
//                       <FiUser size={22} className="text-[#0C4550]/40" /> 
//                     </div> 
//                     <p className="text-[11px] font-extrabold text-[#0C4550] uppercase tracking-tight font-manrope"> 
//                       {formData.senderId || "Sender ID"} 
//                     </p> 
//                     <div className="text-center mt-1"> 
//                       <p className="text-[9px] font-bold text-slate-500 font-manrope">SMS</p> 
//                       <p className="text-[8px] text-slate-400 font-manrope"> 
//                         {formatSubHeaderDate(currentTime)} 
//                       </p> 
//                     </div> 
//                   </div> 

//                   <div className="flex flex-col gap-2"> 
//                     {formData.message ? ( 
//                       <div className="self-start max-w-[90%] bg-[#E9E9EB] text-[#0C4550] p-3 rounded-2xl rounded-tl-none text-[11px] leading-relaxed shadow-sm font-medium animate-in fade-in slide-in-from-left-2 duration-300"> 
//                         {formData.message} 
//                       </div> 
//                     ) : ( 
//                       <div className="self-center mt-12 text-center opacity-40"> 
//                         <p className="text-[10px] font-bold text-[#0C4550] font-manrope uppercase tracking-widest">Live Preview</p> 
//                         <p className="text-[9px] text-[#0C4550] mt-1 italic px-4 leading-tight">Fill the form to see a live simulation of your SMS</p> 
//                       </div> 
//                     )} 
//                   </div> 
//                 </div> 
//               </div> 

//               <div className="h-8 flex justify-center items-center"> 
//                 <div className="w-16 h-1 bg-[#0C4550]/10 rounded-full"></div> 
//               </div> 
//             </div> 

//             <div className="mt-6"> 
//               <button 
//                 onClick={() => navigate('/reports')} 
//                 className="text-[#0C4550] font-bold text-sm underline underline-offset-4 decoration-[#0C4550]/30 hover:decoration-[#F46653] transition-all duration-300 font-manrope" 
//               > 
//                 Check Reports &rarr; 
//               </button> 
//             </div> 
//           </div> 
//         </div> 
//       </div> 
//     </div> 
//   ); 
// }; 

// export default SendSingleSms;




import React, { useState, useEffect } from "react"; 
import { message as antMessage } from "antd"; 
import { getAccessToken } from "../../token"; 
import { API_URL } from "../../Constants"; 
import toast from "react-hot-toast"; 
import { useNavigate } from "react-router-dom"; 
import { motion, AnimatePresence } from "framer-motion"; 

// --- Icons --- 
const FiSend = ({ size = 16, className = "" }) => ( 
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><line x1="22" y1="2" x2="11" y2="13"></line><polygon points="22 2 15 22 11 13 2 9 22 2"></polygon></svg> 
); 
const FiFileText = ({ size = 16, className = "" }) => ( 
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg> 
); 
const FiUser = ({ size = 16, className = "" }) => ( 
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg> 
); 
const FiMessageSquare = ({ size = 16, className = "" }) => ( 
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg> 
); 
const FiRefreshCw = ({ size = 16, className = "" }) => ( 
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><polyline points="23 4 23 10 17 10"></polyline><polyline points="1 20 1 14 7 14"></polyline><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path></svg> 
); 
const FiPhone = ({ size = 16, className = "" }) => ( 
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg> 
); 
const FiAlertCircle = ({ size = 16, className = "" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
);

// --- Form Components --- 
const FormInput = ({ label, icon: Icon, note, readOnly, ...props }) => ( 
  <div className="mb-4"> 
    <label className="block text-[11px] font-bold text-[#0C4550]/70 uppercase tracking-wider mb-1.5 font-manrope"> 
      {label} {props.required && <span className="text-[#F46653] ml-1">*</span>} 
    </label> 
    <div className="relative group"> 
      <input 
        {...props} 
        readOnly={readOnly} 
        className={`w-full pl-10 pr-3 py-2.5 border rounded-xl text-sm font-semibold outline-none transition-all duration-300 ${ 
          readOnly  
            ? "bg-[#F0EFEB]/50 border-slate-200 text-slate-500 cursor-not-allowed"  
            : "bg-white border-slate-200 text-[#0C4550] placeholder-slate-400 focus:border-[#0C4550] focus:ring-1 focus:ring-[#0C4550] hover:border-[#0C4550]/50 shadow-sm" 
        }`} 
      /> 
      <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none text-slate-400 group-focus-within:text-[#0C4550] transition-colors"> 
        {Icon && <Icon size={16} />} 
      </div> 
    </div> 
    {note && <p className="mt-1 text-[11px] text-[#0C4550]/60 font-manrope">{note}</p>} 
  </div> 
); 

const FormTextArea = ({ label, icon: Icon, charCount, maxLength = 160, encodingLabel = "GSM-7", ...props }) => { 
  const getCharCountColor = () => { 
    const percentage = (charCount / maxLength) * 100; 
    if (percentage >= 100) return 'text-[#F46653]'; 
    if (percentage >= 80) return 'text-orange-500'; 
    return 'text-slate-400'; 
  }; 
  return ( 
    <div className="mb-4"> 
      <div className="flex justify-between items-center mb-1.5"> 
        <label className="block text-[11px] font-bold text-[#0C4550]/70 uppercase tracking-wider font-manrope"> 
          {label} {props.required && <span className="text-[#F46653] ml-1">*</span>} 
        </label> 
        <div className="flex items-center gap-2">
          <span className="text-[9px] font-extrabold text-[#0C4550]/40 px-1.5 py-0.5 border border-[#0C4550]/10 rounded bg-[#F0EFEB] font-manrope">{encodingLabel}</span>
          <span className={`text-[10px] font-bold ${getCharCountColor()} font-manrope`}> 
            {charCount}/{maxLength} 
          </span> 
        </div>
      </div> 
      <div className="relative group"> 
        <textarea 
          {...props} 
          className="w-full pl-10 pr-3 py-2.5 bg-white border border-slate-200 rounded-xl text-[#0C4550] placeholder-slate-400 text-sm font-medium focus:border-[#0C4550] focus:ring-1 focus:ring-[#0C4550] outline-none transition-all duration-300 hover:border-[#0C4550]/50 shadow-sm resize-none" 
        /> 
        <div className="absolute top-3 left-3 pointer-events-none text-slate-400 group-focus-within:text-[#0C4550] transition-colors"> 
          {Icon && <Icon size={16} />} 
        </div> 
      </div> 
    </div> 
  ); 
}; 

const FormSelect = ({ label, icon: Icon, options, note, ...props }) => ( 
  <div className="mb-4"> 
    <label className="block text-[11px] font-bold text-[#0C4550]/70 uppercase tracking-wider mb-1.5 font-manrope"> 
      {label} {props.required && <span className="text-[#F46653] ml-1">*</span>} 
    </label> 
    <div className="relative group"> 
      <select 
        {...props} 
        className="w-full pl-10 pr-8 py-2.5 bg-white border border-slate-200 rounded-xl text-[#0C4550] text-sm font-semibold focus:border-[#0C4550] focus:ring-1 focus:ring-[#0C4550] outline-none transition-all duration-300 hover:border-[#0C4550]/50 shadow-sm appearance-none disabled:bg-[#F0EFEB]/50 disabled:text-slate-400 cursor-pointer" 
      > 
        {options.map((opt) => ( 
          <option key={opt.value} value={opt.value} disabled={opt.disabled}> 
            {opt.label} 
          </option> 
        ))} 
      </select> 
      <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none text-slate-400 group-focus-within:text-[#0C4550] transition-colors"> 
        {Icon && <Icon size={16} />} 
      </div> 
      <div className="absolute inset-y-0 right-3 flex items-center pointer-events-none text-slate-400"> 
        <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"> 
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" /> 
        </svg> 
      </div> 
    </div> 
    {note && <p className="mt-1 text-[11px] text-red-400 font-manrope">{note}</p>} 
  </div> 
); 

const SendSingleSms = () => { 
  const token = getAccessToken(); 
  const navigate = useNavigate(); 
  
  const [isSubmitting, setIsSubmitting] = useState(false); 
  const [showSuccessOverlay, setShowSuccessOverlay] = useState(false); 
  
  // Real-Time Clock
  const [currentTime, setCurrentTime] = useState(new Date()); 

  // --- DLT State ---
  const [peId, setPeId] = useState("");
  const [senderIds, setSenderIds] = useState([]);
  const [allTemplates, setAllTemplates] = useState([]);
  const [filteredTemplates, setFilteredTemplates] = useState([]);

  // --- SMS Logic State ---
  const [smsLimit, setSmsLimit] = useState(160);
  const [encodingLabel, setEncodingLabel] = useState("GSM-7");
  const [showLimitWarning, setShowLimitWarning] = useState(false);

  const [formData, setFormData] = useState({ 
    phoneNumber: "", 
    message: "", 
    senderId: "", 
    templateName: "", // Replaced templateID with templateName
    templateID: ""    // Kept as auto-filled secondary field
  }); 

  // Clock interval
  useEffect(() => { 
    const timer = setInterval(() => setCurrentTime(new Date()), 1000); 
    return () => clearInterval(timer); 
  }, []); 

  // Fetch DLT Profile, Sender IDs, and Templates on mount
  useEffect(() => {
    const fetchDltData = async () => {
      if (!token) return;

      const headers = {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json"
      };

      try {
        const profileRes = await fetch(`${API_URL}/api/dlt/profile`, { headers });
        if (profileRes.ok) {
          const profileData = await profileRes.json();
          setPeId(profileData.peId || "");
        }

        const senderRes = await fetch(`${API_URL}/api/dlt/sender-ids`, { headers });
        if (senderRes.ok) {
          const senderData = await senderRes.json();
          setSenderIds(senderData.map(s => s.header));
        }

        const templateRes = await fetch(`${API_URL}/api/dlt/templates`, { headers });
        if (templateRes.ok) {
          const templateData = await templateRes.json();
          setAllTemplates(templateData);
        }
      } catch (error) {
        antMessage.error("Failed to load DLT configuration");
      }
    };

    fetchDltData();
  }, [token]);

  // Encoding detection logic
  const detectEncoding = (text) => {
    const gsm7Basic = "@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !\"#¤%&'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà";
    const gsm7Extended = "^{}\\[]~|€";
    
    for (let i = 0; i < text.length; i++) {
        if (!gsm7Basic.includes(text[i]) && !gsm7Extended.includes(text[i])) {
            return "UNICODE";
        }
    }
    return "GSM-7";
  };

  // Handle encoding and limit updates
  useEffect(() => {
    const encoding = detectEncoding(formData.message);
    const limit = encoding === "UNICODE" ? 70 : 160;
    
    setEncodingLabel(encoding);
    setSmsLimit(limit);

    if (formData.message.length > limit) {
        setShowLimitWarning(true);
    } else {
        setShowLimitWarning(false);
    }
  }, [formData.message]);

  // Filter templates when a Sender ID is selected
  useEffect(() => { 
    if (!formData.senderId) { 
      setFilteredTemplates([]); 
      setFormData(prev => ({ ...prev, templateName: "", templateID: "", message: "" }));
    } else { 
      const filtered = allTemplates.filter(t => 
        t.senderIds && t.senderIds.includes(formData.senderId)
      ); 
      setFilteredTemplates(filtered); 
    } 
  }, [formData.senderId, allTemplates]); 

  // Auto-fill Template ID and message content when a Template Name is selected
  useEffect(() => { 
    if (formData.templateName) { 
      const selectedTemp = allTemplates.find(t => t.templateName === formData.templateName);
      if (selectedTemp) {
        setFormData(prev => ({ 
          ...prev, 
          templateID: selectedTemp.templateId, 
          message: selectedTemp.content 
        })); 
      }
    } else {
      setFormData(prev => ({ ...prev, templateID: "", message: "" }));
    }
  }, [formData.templateName, allTemplates]); 

  const handleChange = (e) => { 
    const { name, value } = e.target; 
    if (name === "senderId") { 
        setFormData(prev => ({ ...prev, [name]: value, templateName: "", templateID: "", message: "" })); 
    } else { 
        setFormData(prev => ({ ...prev, [name]: value })); 
    } 
  }; 

  const resetForm = () => { 
    setFormData({ phoneNumber: "", message: "", senderId: "", templateName: "", templateID: "" }); 
  }; 

  const handleSubmit = async (e) => { 
    e.preventDefault(); 
    
    if (!peId) {
       toast.error("No registered PE ID found. Please update your DLT profile.");
       return;
    }

    setIsSubmitting(true); 
      
    const payload = { 
      recipientNumber: formData.phoneNumber.trim(), 
      senderId: formData.senderId, 
      templateId: formData.templateID, // Payload sends Template ID, not Name
      messageContent: formData.message, 
      peId: peId 
    }; 

    try { 
      const response = await fetch (`${API_URL}/api/v1/sms/send`, { 
        method: "POST", 
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` }, 
        body: JSON.stringify(payload), 
      }); 
        
      let result = null; 
      try { result = await response.json(); } catch { result = null; } 
        
      if (response.ok) { 
        setShowSuccessOverlay(true); 
        toast.success("SMS Submitted Successfully"); 
        resetForm(); 
        setTimeout(() => setShowSuccessOverlay(false), 3000); 
      } else { 
        toast.error(result?.message || "Failed to send SMS"); 
      } 
    } catch (error) { 
      toast.error("Network error occurred"); 
    } finally { 
      setIsSubmitting(false); 
    } 
  }; 

  const formatTopTime = (date) => date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }); 
  const formatSubHeaderDate = (date) => { 
    const day = date.toLocaleDateString('en-US', { weekday: 'short' }); 
    const fullDate = date.toLocaleDateString('en-US', { day: '2-digit', month: 'short', year: 'numeric' }); 
    const time = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }); 
    return `${day}, ${fullDate} • ${time}`; 
  }; 

  const senderOptions = [ 
    { value: "", label: "Select Sender ID", disabled: true }, 
    ...senderIds.map(id => ({ value: id, label: id })) 
  ]; 

  const templateNameOptions = [ 
    { value: "", label: "Select Template Name", disabled: true }, 
    ...filteredTemplates.map(t => ({ value: t.templateName, label: t.templateName })) 
  ]; 

  return ( 
    <div className="min-h-screen bg-[#F0EFEB] p-4 font-sans flex justify-center text-[#0C4550]"> 
      <style>{` 
        @import url('https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800&display=swap'); 
        .font-manrope { font-family: 'Manrope', sans-serif; } 
      `}</style> 

      <div className="w-full max-w-3xl space-y-4"> 
        {/* Header */} 
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 bg-white/40 backdrop-blur-md px-4 py-3 rounded-2xl border border-white/50 shadow-sm"> 
          <div className="pl-1"> 
            <h1 className="text-xl font-extrabold text-[#0C4550] font-manrope">Single SMS Transmission</h1> 
            <p className="text-[#0C4550]/60 text-xs font-medium mt-0.5 font-manrope">Send individual transactional or OTP messages securely</p> 
          </div> 
          <button 
            onClick={resetForm} 
            className="flex items-center gap-1.5 px-4 py-2 bg-white border border-transparent text-[#0C4550] font-bold rounded-lg hover:bg-[#F46653]/10 hover:text-[#F46653] transition-all duration-300 text-xs shadow-sm font-manrope" 
          > 
            <FiRefreshCw size={13} /> Reset Form 
          </button> 
        </div> 

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-5"> 
          {/* Main Form Area */} 
          <div className="lg:col-span-8"> 
            <div className="bg-white rounded-xl shadow-[0_4px_20px_-4px_rgba(12,69,80,0.05)] border border-white overflow-hidden"> 
              <div className="px-5 py-3 bg-[#0C4550]/5 border-b border-[#F0EFEB] flex items-center justify-between"> 
                <div className="flex items-center gap-3"> 
                  <div className="w-8 h-8 rounded-lg bg-[#0C4550] flex items-center justify-center text-white shadow-lg shadow-[#0C4550]/20"> 
                    <FiSend className="w-4 h-4" /> 
                  </div> 
                  <div> 
                    <p className="font-bold text-[#0C4550] font-manrope text-sm">Compose Message</p> 
                    <p className="text-[#0C4550]/50 text-[10px] font-medium font-manrope">Select headers and template to proceed</p> 
                  </div> 
                </div> 
              </div> 

              <form onSubmit={handleSubmit} className="p-5"> 
                <div className="flex flex-col"> 
                  <FormSelect  
                      label="Sender ID"  
                      name="senderId"  
                      value={formData.senderId}  
                      onChange={handleChange}  
                      icon={FiUser} 
                      options={senderOptions} 
                      required  
                  /> 
                  <FormSelect  
                      label="Template Name"  
                      name="templateName"  
                      value={formData.templateName}  
                      onChange={handleChange}  
                      icon={FiFileText} 
                      options={templateNameOptions} 
                      required  
                      note={!formData.senderId ? "Select a Sender ID to view linked templates." : "Matching templates for selected Sender."} 
                  /> 

                  {/* New Field: Template ID (Automatically filled) */}
                  <FormInput 
                    label="Template ID"
                    name="templateID"
                    value={formData.templateID}
                    readOnly
                    placeholder="Auto-filled from template..."
                    icon={FiFileText}
                  />

                  <FormTextArea  
                    label="Message Content"  
                    name="message"  
                    value={formData.message}  
                    onChange={handleChange}  
                    placeholder="Content will auto-fill from template..."  
                    icon={FiMessageSquare} 
                    required  
                    rows={4} 
                    charCount={formData.message.length} 
                    maxLength={smsLimit}
                    encodingLabel={encodingLabel}
                  /> 

                  <AnimatePresence>
                    {showLimitWarning && (
                      <motion.div 
                        initial={{ opacity: 0, y: -10 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -10 }}
                        className="mb-4 p-3 bg-orange-50 border border-orange-200 rounded-xl flex items-start gap-3 shadow-sm"
                      >
                        <div className="mt-0.5 text-orange-500">
                          <FiAlertCircle size={18} />
                        </div>
                        <div>
                          <p className="text-[11px] font-bold text-orange-800 font-manrope uppercase">Message Limit Exceeded</p>
                          <p className="text-[10px] text-orange-700 font-medium font-manrope leading-tight mt-0.5">
                            Your message exceeds the {smsLimit} character limit for {encodingLabel} encoding. 
                            It will be processed and charged as <span className="font-bold">2 or more messages</span>.
                          </p>
                        </div>
                      </motion.div>
                    )}
                  </AnimatePresence>

                  <FormInput  
                    label="Recipient Number"  
                    name="phoneNumber"  
                    value={formData.phoneNumber}  
                    onChange={handleChange}  
                    placeholder="e.g. 919876543210"  
                    icon={FiPhone} 
                    required  
                  /> 
                </div> 

                <div className="mt-2 pt-4 border-t border-[#F0EFEB]"> 
                  <button 
                    type="submit" 
                    disabled={isSubmitting} 
                    className="w-full px-6 py-3 bg-[#0C4550] text-white font-bold rounded-xl transition-all duration-300 disabled:opacity-70 disabled:cursor-not-allowed flex items-center justify-center gap-2 hover:bg-[#08313a] shadow-lg shadow-[#0C4550]/20 hover:shadow-xl hover:-translate-y-0.5 font-manrope text-sm" 
                  > 
                    {isSubmitting ? ( 
                      <> 
                        <div className="w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin"></div> 
                        Processing... 
                      </> 
                    ) : ( 
                      <> 
                        <FiSend size={16} /> Send Message 
                      </> 
                    )} 
                  </button> 
                </div> 
              </form> 
            </div> 
          </div> 

          {/* Right Column - Phone Mockup */} 
          <div className="lg:col-span-4 flex flex-col items-center"> 
            <div className="relative w-[240px] h-[480px] bg-white border-[6px] border-[#0C4550] rounded-[3rem] shadow-2xl flex flex-col overflow-hidden"> 
                
              {/* Speaker/Notch */} 
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-6 bg-[#0C4550] rounded-b-2xl z-20 flex items-center justify-center"> 
                <div className="w-8 h-1 bg-white/20 rounded-full"></div> 
              </div> 
                
              {/* PREMIUM SUCCESS OVERLAY */} 
              <AnimatePresence> 
                {showSuccessOverlay && ( 
                  <motion.div  
                    initial={{ opacity: 0 }} 
                    animate={{ opacity: 1 }} 
                    exit={{ opacity: 0 }} 
                    className="absolute inset-0 z-50 bg-[#0C4550]/95 backdrop-blur-md flex flex-col items-center justify-center px-6 text-center" 
                  > 
                    <motion.div 
                      initial={{ scale: 0, rotate: -45 }} 
                      animate={{ scale: 1, rotate: 0 }} 
                      transition={{ type: "spring", damping: 12, stiffness: 200 }} 
                      className="w-20 h-20 bg-white rounded-full flex items-center justify-center shadow-2xl mb-6" 
                    > 
                      <motion.svg  
                        width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#F46653" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" 
                        initial={{ pathLength: 0 }} 
                        animate={{ pathLength: 1 }} 
                        transition={{ delay: 0.2, duration: 0.5 }} 
                      > 
                        <polyline points="20 6 9 17 4 12"></polyline> 
                      </motion.svg> 
                    </motion.div> 
                      
                    <motion.div 
                      initial={{ y: 20, opacity: 0 }} 
                      animate={{ y: 0, opacity: 1 }} 
                      transition={{ delay: 0.4 }} 
                    > 
                      <h2 className="text-white font-extrabold font-manrope text-xl tracking-tight">SUCCESS!</h2> 
                      <p className="text-white/60 text-[10px] font-bold mt-2 font-manrope uppercase tracking-widest leading-tight"> 
                        Message Sent <br /> Successfully 
                      </p> 
                    </motion.div> 
                  </motion.div> 
                )} 
              </AnimatePresence> 

              {/* Screen Content */} 
              <div className="flex-1 bg-[#F9FAFB] m-1 rounded-[2.2rem] overflow-hidden flex flex-col"> 
                <div className="h-8 flex justify-between items-center px-6 pt-2"> 
                  <span className="text-[10px] font-bold text-[#0C4550] font-manrope"> 
                    {formatTopTime(currentTime)} 
                  </span> 
                  <div className="flex gap-1 items-center"> 
                    <div className="w-2.5 h-2.5 rounded-full border border-[#0C4550]/20"></div> 
                    <div className="w-3 h-2 bg-[#0C4550]/30 rounded-sm"></div> 
                  </div> 
                </div> 

                <div className="flex-1 p-4 flex flex-col"> 
                  <div className="flex flex-col items-center mb-6 mt-4"> 
                    <div className="w-11 h-11 bg-[#0C4550]/10 rounded-full flex items-center justify-center mb-2"> 
                      <FiUser size={22} className="text-[#0C4550]/40" /> 
                    </div> 
                    <p className="text-[11px] font-extrabold text-[#0C4550] uppercase tracking-tight font-manrope"> 
                      {formData.senderId || "Sender ID"} 
                    </p> 
                    <div className="text-center mt-1"> 
                      <p className="text-[9px] font-bold text-slate-500 font-manrope">SMS</p> 
                      <p className="text-[8px] text-slate-400 font-manrope"> 
                        {formatSubHeaderDate(currentTime)} 
                      </p> 
                    </div> 
                  </div> 

                  <div className="flex flex-col gap-2"> 
                    {formData.message ? ( 
                      <div className="self-start max-w-[90%] bg-[#E9E9EB] text-[#0C4550] p-3 rounded-2xl rounded-tl-none text-[11px] leading-relaxed shadow-sm font-medium animate-in fade-in slide-in-from-left-2 duration-300"> 
                        {formData.message} 
                      </div> 
                    ) : ( 
                      <div className="self-center mt-12 text-center opacity-40"> 
                        <p className="text-[10px] font-bold text-[#0C4550] font-manrope uppercase tracking-widest">Live Preview</p> 
                        <p className="text-[9px] text-[#0C4550] mt-1 italic px-4 leading-tight">Fill the form to see a live simulation of your SMS</p> 
                      </div> 
                    )} 
                  </div> 
                </div> 
              </div> 

              <div className="h-8 flex justify-center items-center"> 
                <div className="w-16 h-1 bg-[#0C4550]/10 rounded-full"></div> 
              </div> 
            </div> 

            <div className="mt-6"> 
              <button 
                onClick={() => navigate('/reports')} 
                className="text-[#0C4550] font-bold text-sm underline underline-offset-4 decoration-[#0C4550]/30 hover:decoration-[#F46653] transition-all duration-300 font-manrope" 
              > 
                Check Reports &rarr; 
              </button> 
            </div> 
          </div> 
        </div> 
      </div> 
    </div> 
  ); 
}; 

export default SendSingleSms;